import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import "./index.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";

const AddNewBusinessPartnerType = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();

  const BusinessPartnerTypeInputs = [

    {
      name: "business_partner_type_name",
      label: "Enter Business Partner Type Name",
      placeholder:"Enter Business Partner Type Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
        maxLength:25
       },
    },
    {
      name: "business_partner_type_desc",
      label: "Description",
      placeholder:"Enter Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const authToken = localStorage.getItem("authToken");

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    BusinessPartnerTypeInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
  
    console.log("formData", formData);
  
    showAlert({
      title: "Are you sure?",
      text: "Do you want to add this Business Partner Type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
       
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = {
            business_partner_type_name: formData.business_partner_type_name,
            business_partner_type_desc: formData.business_partner_type_desc,
            status: formData.status === "Active" ? 1 : 0,
          };
  
          // Make the API request
          const response = await axiosInstance.post('/businesspartnertype/create', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
  
          console.log("Business Partner Type added successfully:", response.data);
  
          // Show success alert
          showAlert({
            title: "Success",
            text: "Business Partner Type added successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            // Navigate after success confirmation
            navigate("/admin/manage-dealer/business-partner-type");
          });
  
        } catch (error) {
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          showAlert({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        showAlert({
          title: "Cancelled",
          text: "Your changes were not saved.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        setLoading(false)
      }
    });
  };
  

  return (
    <>
     {loading ? (
          <Loader />
        ) : (
          <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New Business Partner Type</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Business Partner Type Details
        </span>
        <DynamicForm
          formConfig={BusinessPartnerTypeInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
        )}
        
    </>
  );
};

export default AddNewBusinessPartnerType;
